<template>
    <div class="content">
        <div class="content-head">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="申请日期">
                    <el-date-picker v-model="params.date_start" type="date" style="width: 150px" placeholder="开始日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                    <span style="margin: 0 5px">至</span>
                    <el-date-picker v-model="params.date_end" type="date" style="width: 150px" placeholder="结束日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                </el-form-item>
                <el-form-item label="客户名称">
                    <el-input  autocomplete="on" name="customername" v-model="params.customername" placeholder="" clearable class="el-select-medium" style="width: 150px"></el-input>
                </el-form-item>
                <el-form-item label="工程名称">
                    <el-input  autocomplete="on" name="projectname" v-model="params.projectname" placeholder="" clearable class="el-select-medium" style="width: 150px"></el-input>
                </el-form-item>
                <el-form-item label="ERP订单号">
                    <el-input  autocomplete="on" name="erporderssn" v-model="params.erporderssn" placeholder="" clearable class="el-select-medium" style="width: 150px"></el-input>
                </el-form-item>
                <el-form-item label="发票号">
                    <el-input  autocomplete="on" name="VirtualInvoiceNum" v-model="params.VirtualInvoiceNum" placeholder="" clearable class="el-select-medium" style="width: 150px"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getOrdersInvoiceApplyList(true)" icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onRefresh()" icon="el-icon-refresh" :loading="loadingBtn">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-table">
            <div class="content-table-title">开票管理列表</div>
            <el-table  :row-class-name="tableRowClassName" @row-click="handleRowClick" :data="tableData" :height="maxheight" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" v-loading="loadingBtn">
                <el-table-column prop="Apply_CustomerName" label="客户名称" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Orders_ProjectName" label="工程名称" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Apply_Addtime" label="申请日期" show-overflow-tooltip align="center">
                    <template slot-scope="scope">
                        {{ scope.row.Apply_Addtime | formatDates }}
                    </template>
                </el-table-column>
                <el-table-column prop="Apply_OrdersSN" label="ERP订单号" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="Apply_VirtualInvoiceNum" label="发票号" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="ApplyStatus" label="发票申请状态" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column label="操作" align="center" width="100">
                    <template slot-scope="scope">
                        <div class="operation-bar">
                            <span class="operation-bar-block" @click="handleOpen(scope.row)">查看</span>
                            <span class="operation-bar-block operation-bar-block-del" v-if="scope.row.Apply_Status < 3 && scope.row.Apply_CancelStatus == 0" @click="getOrders_GSTBack_Apply_Cancel(scope.row)">取消</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <Pagination :paginationOptions="paginationOptions" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>
        <el-dialog title="查看" :visible.sync="isDrawer" :before-close="handleClose" width="1200px" :close-on-click-modal="false">
            <div>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">发票类型 ：</div>
                            <div>{{ userDetails.Apply_InvoiceType == 1 ? '普通发票' : '增值税发票' }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">ERP订单号 ：</div>
                            <div>{{ userDetails.Apply_OrdersSN }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">客户名称 ：</div>
                            <div>{{ userDetails.Apply_CustomerName }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">工程名称 ：</div>
                            <div>{{ userDetails.Orders_ProjectName }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">税号 ：</div>
                            <div>{{ userDetails.Apply_TaxCode }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">地址电话 ：</div>
                            <div>{{ userDetails.Apply_Tel }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">开户账号 ：</div>
                            <div>{{ userDetails.Apply_BankAccount }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">EMS Region ：</div>
                            <div>{{ userDetails.Apply_EMSRegion }}</div>
                        </div>
                    </el-col>

                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">注释 ：</div>
                            <div>{{ userDetails.Apply_Remark }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">申请时间 ：</div>
                            <div>{{ userDetails.Apply_Addtime | formatDates }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">申请状态 ：</div>
                            <div>
                                <span :class="userDetails.Resultinfo == '已取消' ? 'is-status-text' : 'sucess-status-text '">{{ userDetails.Resultinfo }}</span>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">快递单号 ：</div>
                            <div>{{ userDetails.Apply_LogisticsCode }}</div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center">
                <el-button @click="handleClose()">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import Pagination from '@/components/Pagination.vue';
import { myMixin } from '@/utils/mixin.js';
import { cloneDeep, debounce } from 'lodash';
import { toLowerCaseKeys } from '@/utils/utils.js';
export default {
    name: 'billingApplication',
    mixins: [myMixin],
    components: {
        Pagination
    },
    data() {
        return {
            loadingBtn: false,
            isDrawer: false,
            params: {},
            userDetails: {
                Orders_ProjectName: 'sdf1456',
                Apply_AdderID: 54,
                Apply_Address: '',
                Apply_Addtime: '2021-07-29T17:45:16.007',
                Apply_Bank: '',
                Apply_BankAccount: '6546542654654654',
                Apply_CancelStatus: 0,
                Apply_CustomerName: '士大夫士大夫士大夫',
                Apply_EMSRegion: 'sdfsdf',
                Apply_ID: 3,
                Apply_InvoiceType: 1,
                Apply_LogisticsCode: '',
                Apply_LogisticsCompany: '',
                Apply_OfficeCode: '郑州1部',
                Apply_OfficeID: 149,
                Apply_OrdersID: 3174,
                Apply_OrdersSN: '21070888264',
                Apply_Remark: '',
                Apply_Status: 0,
                Apply_TaxCode: '54654654',
                Apply_Tel: '21454',
                Apply_VirtualInvoiceNum: '',
                Resultinfo: ''
            },
            tableData: []
        };
    },
    mounted() {
        this.onRefresh();
    },
    methods: {
        /*
    重置查询
    */
        onRefresh() {
            this.params = {
                customername: '',
                projectname: '',
                erporderssn: '',
                VirtualInvoiceNum: '',
                date_start: '',
                date_end: ''
            };
            this.getOrdersInvoiceApplyList(true);
        },
        /*
    列表查询
    */
        getOrdersInvoiceApplyList(flag = false) {
            this.loadingBtn = true;
            if (flag) {
                this.paginationOptions = {
                    Page: 1,
                    total: 0,
                    PageSize: 40
                };
            }
            this.$newsApi
                .getOrdersInvoiceApplyList(this.filteropt())
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.tableData = res.data.data;
                        this.paginationOptions.total = res.data.RecordCount;
                    } else {
                        this.tableData = [];
                        this.paginationOptions.total = 0;
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },
        filteropt() {
            let params = cloneDeep(this.params);
            return { json: JSON.stringify(params), Page: this.paginationOptions.Page, PageSize: this.paginationOptions.PageSize };
        },
        getOrders_GSTBack_Apply_Cancel(row) {
            this.$confirm('执行该操作后将无法恢复，您确定要执行该操作吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$newsApi.getOrders_GSTBack_Apply_Cancel({ ApplyID: row.Apply_ID }).then((res) => {
                        if (res.data.Resultcode == 0) {
                            this.$message({
                                type: 'success',
                                message: '操作成功!',
                                duration: 2000,
                                onClose: () => {
                                    this.onRefresh();
                                }
                            });
                        }
                    });
                })
                .catch(() => {});
        },
        handleSizeChange(newSize) {
            this.paginationOptions.PageSize = newSize;
            this.getOrdersInvoiceApplyList();
        },
        handleCurrentChange(newPage) {
            this.paginationOptions.Page = newPage;
            this.getOrdersInvoiceApplyList();
        },
        handleClose() {
            this.isDrawer = false;
        },
        handleOpen(row) {
            this.isDrawer = true;
            this.$newsApi.getOrdersInvoiceApplyByID({ ApplyID: row.Apply_ID }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.userDetails = res.data.data;
                    this.userDetails.Resultinfo = res.data.Resultinfo;
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.hw-form-item {
    padding: 10px 0;
    display: flex;
    align-items: center;

    &-label {
        text-align: right;
        width: 140px;
    }
}
.hw-form-item {
    padding: 10px 0;
    display: flex;
    align-items: center;

    &-label {
        text-align: right;
        width: 140px;
    }
}
</style>
